const slugify = (str) =>
  String(str)
    .toLowerCase()
    .replace(/&/g, '')
    .replace(/[åä]/g, 'a')
    .replace(/ö/g, 'o')
    .replace(/\W+/g, '_')

export default slugify
